import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};
export default function ContentLayout({ children }: Props) {
  return (
    <div className="w-full bg-light-gray pt-[52px] pl-[52px] pr-[20px] pb-[20px] bg-gray-D flex flex-col gap-[24px] overflow-auto">
      {children}
    </div>
  );
}
